export class ConnectionError extends Error {}
export class ClientError extends Error {}
